module.exports = __webpack_public_path__ + "img/a0f6c25.jpg";